var $ = require('./../sw-jquery');
var url = require('url');
var defaultNotice = 'Could not generate product preview at this time, please try again';
var attempts = 0;
var retryInterval = 2000;
var attemptLimit = 30; // 60 seconds
var sw = require('js/lib/sw');
var _ = require('underscore');
var signupDialog = require('js/lib/notifications/sw-signup-dialog');

function coCreatorAddToCartComplete(response) {
  if(sw.data.isEmbed && sw.data.baseUrl) {
    parent.window.location = sw.data.baseUrl + '/cart';
    return;
  }

  try {
    var parsedResponse = window.JSON.parse(response);
    $('.product-cocreator-form').html(parsedResponse.coCreatorFieldsHtml);
    return;
  } catch(err) {
    //continue happy path if not json
  }

  //hide old errors, if any
  $('.product-cocreator-form .error').hide();

  sw.trigger('cart-add-product', response, _.keys(sw.data.products)[0]);

}

function showCCForm() {
  var $customizeButton = $('[data-sw-product-cocreator]');
  var spin = $customizeButton.attr('data-sw-product-cocreator');

  if(!_.isUndefined($customizeButton.attr('data-sw-product-cocreator-add-to-cart'))) {
    return;
  }
  
  $customizeButton.attr('data-sw-product-cocreator-add-to-cart', spin);
  $customizeButton.attr('data-sw-product-purchase-form-buy-button', '');
  $customizeButton.text('Buy Now');
  $('[data-sw-cocreator-container]').removeClass('hidden');
}

function hideCCForm() {
  var $customizeButton = $('[data-sw-product-cocreator]');
  $customizeButton.removeAttr('data-sw-product-purchase-form-buy-button');
  $customizeButton.removeAttr('data-sw-product-cocreator-add-to-cart');
  $customizeButton.text('Customize');
  $('[data-sw-cocreator-container]').addClass('hidden');
}
$(document).ready(function () {

  var $body = $('body');
  // check for ?personalize=1
  var urlObj = url.parse(window.location.href, true);

  if (urlObj && urlObj.query && urlObj.query.personalize && parseInt(urlObj.query.personalize, 10) === 1) {
    showCCForm();
  }

  $body.on('click', '[data-sw-product-cocreator]', function () {
    if ($(this).hasClass('disabled')) {
      return;
    }

    var LOGIN_SUCCESS_EVENT = 'sw-login-complete.cocreator';
    if(!sw.data.user.isLoggedIn) {
      signupDialog.openLogInSignUpDialog('login', null, 'personalize', null, 'event:' + LOGIN_SUCCESS_EVENT);
      sw.on(LOGIN_SUCCESS_EVENT, function () {
        sw.off(LOGIN_SUCCESS_EVENT);
        showCCForm();
      });
    } else {
      showCCForm();
    }

  });

  $body.on('click', '[data-sw-product-cocreator-cancel]', function () {
    hideCCForm();
  });

  $body.on('click', '[data-sw-product-cocreator-add-to-cart]', function () {
    var $el = $(this);
    require(['js/lib/models/ModelManager'], function (ModelManager) {


      var productSpin = $el.data('swProductCocreatorAddToCart');
      var product = ModelManager.getProduct(productSpin);
      var config = product.getCurrentProductConfiguration();

      var formData = new FormData($('#cocreator-form')[0]);
      formData.append('productConfigurationId', config.productConfigurationId);

      $.ajax({
        url: '/cocreator/cart/add',
        type: 'POST',
        data: formData,
        success: coCreatorAddToCartComplete,
        cache: false,
        contentType: false,
        processData: false
      });
    });

  });

  function enableWaiting() {
    $('.shapejs-preview').addClass('waiting');
  }

  function disableWaiting() {
    $('.shapejs-preview').removeClass('waiting');
  }

  function showNotice() {
    var notice = $('<span class="notice">' + defaultNotice + '</span>');
    $('#shapejs-preview-notices').append(notice);
    setTimeout(function () {
      notice.remove();
    }, 5000);
  }

  function checkJobStatus(jobId) {
    attempts++;
    var options = {
      url: '/shapejs-cocreator?jobId=' + jobId,
      type: 'GET',
      datatype: 'json',
      success: function (data) {
        if (data.status === 'success') {
          if (data.result.aoptUrl === null) {
            // failed to generate output
            showNotice('no_aopt_url_present');
            disableWaiting();
            return;
          }

          // grab the iframe using the path to the aopt file
          var aoptUrl = window.sw.data.imagesUrl + '/3dviewer/aopt-file?aoptFilePath=' + encodeURIComponent(data.result.aoptUrl) + '&width=625&height=465';
          $('#x3d-iframe').attr('src', aoptUrl);
          $('#shapejs-preview-container').removeClass('hidden');
          disableWaiting();
        } else if (data.status === 'pending') {
          if (attempts <= attemptLimit) {
            setTimeout(function () {
              checkJobStatus(jobId);
            }, retryInterval);
          } else {
            showNotice('client_timeout');
            disableWaiting();
          }
        } else {
          showNotice(data.error);
          disableWaiting();
        }
      },
      error: function () {
        // could not contact server
        showNotice('client_connection_failed');
        disableWaiting();
      }
    };
    $.ajax(options);
  }

  function onShapeJsFailure() {
    showNotice('client_connection_failed');
    disableWaiting();
  }

  function onShapeJsSuccess(data) {
    if (data.status === 'success') {
      checkJobStatus(data.jobId);
    } else {
      if (data.coCreatorFieldsHtml) {
        $('.product-cocreator-form').html(data.coCreatorFieldsHtml);
      }
      disableWaiting();
    }
  }

  $body.on('click', '[data-sw-product-cocreator-preview-shapejs]', function () {
    if ($(this).hasClass('waiting')) {
      return;
    }

    $('#cocreator-form .error').remove();
    enableWaiting();
    $('#shapejs-preview-container').addClass('hidden');
    attempts = 0;

    var formData = new FormData($('#cocreator-form')[0]);

    $.ajax({
      url: '/shapejs-cocreator',
      type: 'post',
      datatype: 'json',
      data: formData,
      success: onShapeJsSuccess,
      error: onShapeJsFailure,
      cache: false,
      contentType: false,
      processData: false
    });
  });

});
